import React from "react";

export default function SubtitleTop({ elem }) {
  return (
    <div className={"mb-2"}>
      <h6 className="subtitle">{elem.name}</h6>
    </div>
  );
}
